import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from '../redux/store';
import webServices from '../services/webServices';

// The company whose Service Pro experience the user is currently in (card 53).
//
// The navbar is shared between the homeowner and pro experiences, so the audience
// is decided by the ROUTE rather than by the role: inside /service-pro the bell
// shows the company's shared feed, everywhere else the homeowner's personal one.
// A pro who flips to the homeowner dashboard should see homeowner notifications
// there, which a role check would get wrong.
//
// Resolution mirrors the pro pages (ServiceProDashboard, AddressSearch): prefer
// the company already in redux, fall back to one fetch. Returns null until
// resolved, and null for every non-pro route — callers treat null as "homeowner".
export default function useProCompanyId() {
  const { pathname } = useLocation();
  const companyList = useSelector((state) => state.company.List);
  const [companyId, setCompanyId] = useState(null);

  const isProRoute = pathname.startsWith('/service-pro');

  useEffect(() => {
    let active = true;
    if (!isProRoute) {
      setCompanyId(null);
      return undefined;
    }

    const fromStore = Array.isArray(companyList) && companyList.length > 0 ? companyList[0] : null;
    if (fromStore?.id) {
      setCompanyId(fromStore.id);
      return undefined;
    }

    (async () => {
      try {
        const resp = await webServices.getCompany({ params: {} });
        if (!active) return;
        if (resp && resp.success === true && Array.isArray(resp.data) && resp.data.length > 0) {
          setCompanyId(resp.data[0].id || null);
        }
      } catch (e) {
        // No company resolved — the bell just falls back to the homeowner feed.
      }
    })();

    return () => {
      active = false;
    };
  }, [isProRoute, companyList]);

  return isProRoute ? companyId : null;
}
